import glam from 'glamorous';

export const Wrapper = glam.ul({
  margin: 0,
  padding: 0,
  listStyle: 'none',
  paddingBottom: '0.6rem',
});

export const Item = glam.li();



// WEBPACK FOOTER //
// ./src/module/View/Menu/Items/ItemCategories.s.ts